import React from 'react';
import { IMainDirectoryListItem } from '../../../graphql/useAllMainDirectoryListQuery';

interface ISaveView {
    onSave: (id: string) => void;
    currentView: IMainDirectoryListItem | undefined;
}

const SaveViewContext = React.createContext<ISaveView>({} as ISaveView);
export const useSaveView = () => React.useContext(SaveViewContext);

export const SaveViewProvider: React.FC<ISaveView> = ({ children, currentView, onSave }) => {
    return (
        <SaveViewContext.Provider
            value={{
                onSave,
                currentView,
            }}
        >
            {children}
        </SaveViewContext.Provider>
    );
};
